import React from 'react';

const ShippingRequestTable = ({ shippingRequest }) => {
  // Function to render nested objects recursively
  const renderNestedObject = (obj, parentKey = '') => {
    return Object.entries(obj).map(([key, value]) => {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      
      if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
        // Render nested object
        return renderNestedObject(value, fullKey);
      } else if (Array.isArray(value)) {
        // Handle arrays
        return (
          <tr key={fullKey}>
            <td><strong>{fullKey}</strong></td>
            <td>
              {value.length === 0 ? '[]' : (
                <ul className="list-unstyled m-0">
                  {value.map((item, index) => (
                    <li key={index}>
                      {typeof item === 'object' && item !== null 
                        ? JSON.stringify(item) 
                        : String(item)}
                    </li>
                  ))}
                </ul>
              )}
            </td>
          </tr>
        );
      } else {
        // Render primitive values
        return (
          <tr key={fullKey}>
            <td><strong>{fullKey}</strong></td>
            <td>{value === null ? 'null' : String(value)}</td>
          </tr>
        );
      }
    }).flat();
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header bg-info text-white">
              <h5 className="mb-0">Shipping Request Details</h5>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>Property</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {shippingRequest ? (
                      renderNestedObject(shippingRequest)
                    ) : (
                      <tr>
                        <td colSpan="2" className="text-center">No shipping request data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingRequestTable;